import React from 'react';
import Icon from '../../../components/AppIcon';

const DeliveryInfo = () => {
  const deliveryOptions = [
    {
      icon: 'Package',
      title: '무료 픽업 & 배송',
      description: '신내동 전 지역에 한해 무료 비대면 픽업 및 배송을 제공합니다',
    },
    {
      icon: 'MapPin',
      title: '배송 시간',
      description: '자연 건조 후 정돈하여 오후 8시부터 배송합니다 (일요일 휴무)',
    },
    {
      icon: 'Clock',
      title: '픽업 시간',
      description: '오전 9시에 문 앞에서 일괄 수거합니다 (일요일 휴무)',
    },
    {
      icon: 'Bell',
      title: '알림 서비스',
      description: '카카오톡으로 픽업, 세척 진행, 배송 완료 알림을 보내드립니다.',
    },
  ];

  return (
    <div className="rounded-xl bg-card p-6 shadow-lg">
      <h3 className="mb-6 text-xl font-bold text-foreground">픽업 & 배송 안내</h3>
      <div className="grid gap-6 sm:grid-cols-2">
        {deliveryOptions?.map((option, index) => (
          <div key={index} className="flex gap-4">
            <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg bg-primary/10">
              <Icon name={option?.icon} size={24} color="var(--color-primary)" />
            </div>
            <div>
              <h4 className="mb-1 font-semibold text-foreground">{option?.title}</h4>
              <p className="text-sm text-muted-foreground">{option?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 rounded-lg bg-muted/50 p-4">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-accent)" className="mt-0.5 flex-shrink-0" />
          <p className="text-sm text-foreground">
            신발은 현관문 앞 또는 문고리에 맡겨주세요. 배송 시에도 동일한 방식으로 전달됩니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DeliveryInfo;